import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { UserdataModel } from '../providers/userdata-model';
import { Functions } from './functions';

/* Chunks Data are in the variable chunksData in this provider 
It contains all regarding game rules */

@Injectable()
export class GamerulesModel {
    scoreExactlyOnPar:number=100;
    chunksData: any=[];
    // EX. {"idChunk":1,"idBook":1,"idChunkInBook":0,"chunkStart":0,"chunkEnd":119}
    scoreParData: any=[];
    // EX. {"idChunk":433,"bookmarkInChunk":69,"letter":"r","par":10,"parVersion":1}
    levelAdvancementTable=[0,3000,9000,27000,65000,140000,230000,340000,480000,640000,850000,1000000,1200000,1400000,1650000,1950000,2250000,2650000,3050000,3550000];

    collectiblesData: any=[];
    constructor(private storage: Storage, public userdataModel:UserdataModel, public functions: Functions){
		this.getChunksDataStored();
    }

    /* --------- GETTER/SETTER --------- */

    setWholeChunksData(chunksData){
        this.chunksData=chunksData;
        this.storeChunksData();
    }

    getWholeChunksData(){
        return this.chunksData;
    }

    storeChunksData(){
        return new Promise((resolve) =>{
            this.storage.set('chunksData', JSON.stringify(this.chunksData)).then((val) => {
                resolve("storechunksDataOk");
            })
        });
    }

    setWholeCollectiblesData(collectiblesData){
        this.collectiblesData=collectiblesData;
        this.storeCollectiblesData();
    }

    getWholeCollectiblesData(){
        return this.collectiblesData;
    }

    storeCollectiblesData(){
        return new Promise((resolve) =>{
            this.storage.set('collectiblesData', JSON.stringify(this.collectiblesData)).then((val) => {
                resolve("storeCollectiblesDataOk");
            })
        });
    }

    getCollectibleIdFromShortname(shortname){
        for (let i = 0; i < this.collectiblesData.length; i++) {
            if(this.collectiblesData[i].shortname==shortname){
                return this.collectiblesData[i].id;
            }
        }
    }

    getCollectibleShortnameFromId(id){
        for (let i = 0; i < this.collectiblesData.length; i++) {
            if(this.collectiblesData[i].id==id){
                return this.collectiblesData[i].shortname;
            }
        }
    }

    getQuantityArrayForCollectibleId(collectibleId){
        for (let i = 0; i < this.collectiblesData.length; i++) {
            if(this.collectiblesData[i].id==collectibleId){
                return this.collectiblesData[i].quantitysteps.split(",");
            }
        }
    }

    getIsglobalforanybookForCollectibleId(collectibleId){
        for (let i = 0; i < this.collectiblesData.length; i++) {
            if(this.collectiblesData[i].id==collectibleId){
                return this.collectiblesData[i].isglobalforanybook;
            }
        }
    }

    getChunksDataStored(){
        this.storage.get('chunksData').then((chunksData) => {
            if(chunksData){
                this.chunksData=JSON.parse(chunksData);
            }else{
                this.chunksData=[];
            }
        });
    }

    clearChunksData(){
        return new Promise((resolve) =>{
            this.chunksData=[];
            this.chunksData.push({});
            this.storeChunksData().then((response)=>{
                resolve("storeChunksDataOk");
            });
        });
    }

    getChunksOfBook(idBook){
        return this.chunksData.filter(obj=>obj.idBook==idBook);
    }

    getNumChunksOfBook(idBook){
        return this.getChunksOfBook(idBook).length;
    }

    getChunkStart(idBook,idChunkInBook){
        var result;
        result=this.chunksData.filter(obj=>obj.idBook==idBook && obj.idChunkInBook==idChunkInBook);

        if (result[0]) {
            return result[0].chunkStart;
        }else{
            console.log("ERROR: Chunk Start "+idChunkInBook+" of book "+idBook+" not found!");
            return -1;
        }
    }

    getChunkEnd(idBook,idChunkInBook){
        var result=this.chunksData.filter(obj=>obj.idBook==idBook && obj.idChunkInBook==idChunkInBook);
        if (result[0]) {
            //Last char must not be considered
            return result[0].chunkEnd-1;
        }else{
            console.log("ERROR: Chunk End "+idChunkInBook+" of book "+idBook+" not found!");
            return -1;
        }
    }

    getChunkLength(idBook,idChunkInBook){
        var chunkStart=this.getChunkStart(idBook,idChunkInBook);
        var chunkEnd=this.getChunkEnd(idBook,idChunkInBook);
        if (chunkStart<0) {
            console.log("ERROR: Chunk Lenght not found! Chunk Start "+chunkStart+" of book "+idBook+" idChunkInBook: "+idChunkInBook);
            return -1;
        }
        if (chunkEnd<0) {
            console.log("ERROR: Chunk Lenght not found! Chunk End "+chunkEnd+" of book "+idBook+" idChunkInBook: "+idChunkInBook);
            return -1;
        }
        return chunkEnd-chunkStart+1;
    }

    /* Retuns i-j interval of idChunk in which startBookmark and endBookmark are contained */
    getIntervalIdChunk(idBook,startBookmark,endBookmark){
        //console.log("getIntervalIdChunk of idBook: "+idBook+" startBookmark:"+startBookmark+" endBookmark"+endBookmark);
        var result=this.chunksData.filter(
            obj=>obj.idBook==idBook 
                && (
                    (startBookmark>=obj.chunkStart && startBookmark<=obj.chunkEnd) 
                    || (endBookmark>=obj.chunkStart && endBookmark<=obj.chunkEnd) 
                    || (startBookmark>=obj.chunkStart && endBookmark<=obj.chunkEnd) 
                    || (startBookmark<=obj.chunkStart && endBookmark>=obj.chunkEnd) 
                )
            );
            
        //console.log("this.chunksData: "+JSON.stringify(this.chunksData));
        //console.log("intervalIdChunk: "+JSON.stringify(result));
        
        var minChunkId=Infinity;
        var maxChunkId=-1;
        if (result[0]) {
            for (let i = 0; i < result.length; i++) {
                if (result[i].idChunk<minChunkId) {
                    minChunkId=result[i].idChunk;
                }
                if (result[i].idChunk>maxChunkId) {
                    maxChunkId=result[i].idChunk;
                }
            }
            return [minChunkId,maxChunkId];
        }else{
            console.log("ERROR: idChunk Interval between bookmarks "+startBookmark+" and "+endBookmark+" of book "+idBook+" not found!");
            return -1;
        }
    }

    // Find chunkInBook for this boomarkLetter in this idBook
    getChunkFromBookmarkLetter(idBook,boomarkLetter){
        var chunkInBook=this.chunksData.filter(obj=>
            obj.idBook==idBook
             && (
                 (boomarkLetter>obj.chunkStart && boomarkLetter<obj.chunkEnd)
                 || boomarkLetter==obj.chunkStart
                 || boomarkLetter==obj.chunkEnd                 
                )                
            );
        if (!this.functions.isObjectEmpty(chunkInBook)) {
            //console.log("chunkInBook.idChunkInBook: "+chunkInBook[0].idChunkInBook);
            return chunkInBook[0].idChunkInBook;
        }else{
            console.log("ERROR: ChunkInBook for bookmark "+boomarkLetter+" in book "+idBook+" not found!");
            return -1;
        }
    }

    setWholeScoreParData(scoreParData){
        this.scoreParData=scoreParData;
        this.storeScoreParData();
    }

    getWholeScoreParData(){
        return this.scoreParData;
    }

    storeScoreParData(){
        return new Promise((resolve) =>{
            this.storage.set('scoreParData', JSON.stringify(this.scoreParData)).then((val) => {
                resolve("storescoreParDataOk");
            })
        });
    }

    getScoreParDataStored(){
        this.storage.get('scoreParData').then((scoreParData) => {
            if(scoreParData){
                this.scoreParData=JSON.parse(scoreParData);
            }else{
                this.scoreParData=[];
            }
        });
    }

    clearScoreParData(){
        return new Promise((resolve) =>{
            this.scoreParData=[];
            this.scoreParData.push({});
            this.storeScoreParData().then((response)=>{
                resolve("storescoreParDataOk");
            });
        });
    }

    getParsOfTextblock(idBook,startBookmark,endBookmark){
        var idChunkInterval=this.getIntervalIdChunk(idBook,startBookmark,endBookmark);
        console.log("idChunkInterval: "+idChunkInterval);
        return this.scoreParData.filter(obj=>(
               (
                (obj.idChunk>idChunkInterval[0] && obj.idChunk<idChunkInterval[1] )
                || obj.idChunk==idChunkInterval[0]
                || obj.idChunk==idChunkInterval[1]                
               )  
               && 
               (
                (obj.bookmarkInChunk>startBookmark && obj.bookmarkInChunk<endBookmark )
                || obj.bookmarkInChunk==startBookmark
                || obj.bookmarkInChunk==endBookmark                
               )  
            ));
        // was return this.scoreParData.filter(obj=>(obj.idChunk>=idChunkInterval[0] && obj.idChunk<=idChunkInterval[1] && obj.bookmarkInChunk>=startBookmark && obj.bookmarkInChunk<=endBookmark));
    }

    calculateScore(numAttempts,par){
        return Math.round(this.scoreExactlyOnPar * Math.pow( 2, -((numAttempts-par)/par)));
    }

    calculateScoreForNextAttempt(numAttempts,par){
        return this.calculateScore(numAttempts+1,par);
    }

    /* This suppose server gave back only record with the correct par */
    getParVersion(){
        //console.log("scorePardata: "+ JSON.stringify(this.scoreParData));
        return this.scoreParData[0].parVersion;
    }

    getLevelFromScore(score){
        var level=-1;
        for (let i = 0; i < this.levelAdvancementTable.length; i++) {
            if ((score>this.levelAdvancementTable[i] && score<this.levelAdvancementTable[i+1])) { level=i; break; }
            if (score==this.levelAdvancementTable[i]) { level=i; break; }
            if (score==this.levelAdvancementTable[i+1]) { level=i+1; break; }
        }
        if (score>=this.levelAdvancementTable[this.levelAdvancementTable.length-1]) {
             level=this.levelAdvancementTable.length-1; 
        }
         
        if (level!=-1) {
            return level+1; // +1 for level starts from 1
        }else{
            console.log("ERROR: Score "+score+" not found in advancement table!");
            return -1;
        } 
    }

    getProgressInLevelFromScore(score){
        var indexLevel=this.getLevelFromScore(score)-1;
        var pxTotalInThisLevel=this.levelAdvancementTable[indexLevel+1]-this.levelAdvancementTable[indexLevel];
        var pxEarned=score-this.levelAdvancementTable[indexLevel];
        
        return this.functions.calculatePercentage(pxEarned,pxTotalInThisLevel,"progress in level");
    }

    /* --------- END --------- GETTER/SETTER --------- */
}


// WEBPACK FOOTER //
// ./src/providers/gamerules-model.ts